import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12c0 1.657 4.03 3 9 3s9 -1.343 9 -3","key":"svg-0"}],["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-1"}]]

const IconSphere = createReactComponent('outline', 'sphere', 'Sphere', __iconNode);

export default IconSphere;